import { Box, FormHelperText, createStyles, makeStyles } from '@material-ui/core';
import { FC } from 'react';
import styles from './styles';

const ErrorText: FC = ({ children }) => {
  const { authError } = makeStyles((theme) => createStyles(styles(theme)))();
  return (
    <Box position="relative">
      <FormHelperText className={authError}>{children}</FormHelperText>
    </Box>
  );
};

export default ErrorText;
